/* eslint-disable no-undef */
import React, { useState, useEffect, useCallback, useMemo } from 'react';

import PlayerUv from '../Players/PlayerUv';
import PlayerRicm from '../Players/PlayerRicm';
import PlayerFwi from '../Players/fwi/PlayerFwi';

const Principal = () => {
    //return <PlayerUv />
    //return <PlayerRicm />
    return <PlayerFwi />
}







export default Principal;